import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Forms from "./forms";
import Templates from "./templates";

const feature = "templates";

const InitialState = Record({
  forms: new Forms(),
  templates: new Templates()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function TemplatesReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.templates
    ) {
      state = state.updateIn(["templates", "entities"], map =>
        map.mergeDeep(action.payload.entities.templates));
    }
  }

  switch (action.type) {
    case actions.GET_TEMPLATES: {
      return state.setIn(["templates", "loading"], true);
    }
    case actions.GET_TEMPLATES_SUCCESS: {
      state = state.deleteIn(["templates", "entities"]);
      state = state.deleteIn(["templates", "results"]);
      state = state.setIn(
        ["templates", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["templates", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["templates", "entities"], map =>
        map.mergeDeep(action.payload.entities.templates));
      state = state.setIn(
        ["templates", "results"],
        action.payload.result.templates
      );
      return state.setIn(["templates", "loading"], false);
    }
    case actions.GET_TEMPLATES_ERROR: {
      return state.setIn(["templates", "loading"], false);
    }

    case actions.GET_TEMPLATE: {
      return state.setIn(["templates", "loading"], true);
    }
    case actions.GET_TEMPLATE_SUCCESS: {
      return state.setIn(["templates", "loading"], false);
    }
    case actions.GET_TEMPLATE_ERROR: {
      return state.setIn(["templates", "loading"], false);
    }

    case actions.POST_TEMPLATES: {
      return disableForm(state, "createTemplate");
    }
    case actions.POST_TEMPLATES_SUCCESS: {
      state = clearForm(state, "createTemplate", Forms);
      return enableForm(state, "createTemplate");
    }
    case actions.POST_TEMPLATES_ERROR: {
      state = enableForm(state, "createTemplate");
      return setFormErrors(state, "createTemplate", action.payload.errors);
    }

    case actions.PATCH_TEMPLATE: {
      return state.setIn(["templates", "loading"], true);
    }
    case actions.PATCH_TEMPLATE_SUCCESS: {
      return state.setIn(["templates", "loading"], false);
    }
    case actions.PATCH_TEMPLATE_ERROR: {
      return state.setIn(["templates", "loading"], false);
    }

    case actions.DELETE_TEMPLATE: {
      return state.deleteIn(["templates", "entities", action.payload.uid]);
    }

    case actions.GET_TEMPLATE_SECTIONS: {
      return state.setIn(["templates", "loading"], true);
    }
    case actions.GET_TEMPLATE_SECTIONS_SUCCESS: {
      state = state.setIn(
        ["templates", "entities", action.meta.uid, "sections"],
        action.payload.result
      );
      return state.setIn(["templates", "loading"], false);
    }
    case actions.GET_TEMPLATE_SECTIONS_ERROR: {
      return state.setIn(["templates", "loading"], false);
    }

    case actions.POST_TEMPLATE_SECTIONS: {
      return disableForm(state, "createTemplateSection");
    }
    case actions.POST_TEMPLATE_SECTIONS_SUCCESS: {
      state = clearForm(state, "createTemplateSection", Forms);
      return enableForm(state, "createTemplateSection");
    }
    case actions.POST_TEMPLATE_SECTIONS_ERROR: {
      state = enableForm(state, "createTemplateSection");
      return setFormErrors(
        state,
        "createTemplateSection",
        action.payload.errors
      );
    }

    case actions.SET_IS_ADD_SECTION_MODAL_VISIBLE: {
      return state.setIn(
        ["forms", "createTemplateSection", "isAddModalVisible"],
        action.payload.isVisible
      );
    }

    case actions.SET_IS_ADD_TEMPLATE_MODAL_VISIBLE: {
      return state.setIn(
        ["forms", "createTemplate", "isAddModalVisible"],
        action.payload.isVisible
      );
    }

    case actions.SET_IS_EDIT_TEMPLATE_MODAL_VISIBLE: {
      return state.setIn(
        ["templates", "isEditModalVisible"],
        action.payload.isVisible
      );
    }

    case actions.SET_IS_REMOVE_TEMPLATE_MODAL_VISIBLE: {
      return state.setIn(
        ["templates", "isRemoveModalVisible"],
        action.payload.isVisible
      );
    }
  }

  return entitiesReducer(
    formsReducer(state, feature, action, Forms),
    feature,
    action
  );
}



// WEBPACK FOOTER //
// ./src/common/templates/reducer.js